import { render } from "./editsalesreturn.vue?vue&type=template&id=cc04b75c"
import script from "./editsalesreturn.vue?vue&type=script&lang=js"
export * from "./editsalesreturn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__